var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3327 8.78853C15.3327 13.031 9.99935 16.6673 9.99935 16.6673C9.99935 16.6673 4.66602 13.031 4.66602 8.78853C4.66602 7.34189 5.22792 5.95451 6.22811 4.93158C7.22831 3.90866 8.58486 3.33398 9.99935 3.33398C11.4138 3.33398 12.7704 3.90866 13.7706 4.93158C14.7708 5.95451 15.3327 7.34189 15.3327 8.78853Z",
    stroke: "#F9FBFE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 10.6067C10.9812 10.6067 11.7771 9.79268 11.7771 8.78853C11.7771 7.78438 10.9812 6.97035 9.99935 6.97035C9.01751 6.97035 8.22157 7.78438 8.22157 8.78853C8.22157 9.79268 9.01751 10.6067 9.99935 10.6067Z",
    stroke: "#F9FBFE",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocation);
export default __webpack_public_path__ + "static/media/pin-location.eba242d68197940f25a07881a51206e8.svg";
export { ForwardRef as ReactComponent };